class ProductMobileGallery extends HTMLElement {
  constructor() {
    super();

    this.initWhenReady();
  }

  initWhenReady() {
    if (typeof Swiper !== "undefined") {
      this.initSwiper();
    } else {
      setTimeout(() => this.initWhenReady(), 100);
    }
  }

  initSwiper() {
    const swiperContainer = this.querySelector(".swiper");

    if (!swiperContainer) return;

    const paginationType = this.getAttribute("pagination-type") || "fraction";

    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      loop: false,
      speed: 400,
      grabCursor: true,
      touchRatio: 1,
      threshold: 5,
      resistance: true,
      resistanceRatio: 0.85,
      pagination: {
        el: ".swiper-pagination",
        type: paginationType,
        clickable: true,
        dynamicBullets: paginationType === "bullets",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

    this.swiper = swiper;
  }
}

customElements.define("product-mobile-gallery", ProductMobileGallery);
